import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RewardsGiftButtonComponent } from "./rewards-gift-button.component";

@NgModule({
    imports: [CommonModule],
    exports: [RewardsGiftButtonComponent],
    declarations: [RewardsGiftButtonComponent],
})
export class RewardsGiftButtonModule {}